import { StyledSpinner } from './ButtonSpinner.styles';

const ButtonSpinnerUraniumBlue = () => {
  return (
    <StyledSpinner src="/svg/loading_uranium_blue.svg" alt="Spinner icon" aria-label="Loading" />
  );
};

export default ButtonSpinnerUraniumBlue;
